import React, { createContext, useState } from 'react';
import client from '../feathers';

const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  client.on('login', async () => {
    const { preferredLanguage } = await client.service('preferences').find();
    setLanguage(preferredLanguage);
  });

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export { LanguageContext, LanguageProvider };
